import { css } from "styled-components";

import { inlineOverlayZIndex } from "../foundations/popover";

/**
 * c6 tooltip 버블의 공용 **시각 표면**(색·radius·타이포·폭·z). 위치(`position`)·표시 토글·페이드는
 * 소비 측이 얹는다. `Tooltip`(per-trigger)과 `TruncationTooltipHost`(공유 단일 버블)가 같은 룩을
 * 쓰도록 한 곳에서 소유한다(재사용 규칙 §3 — 중복 시각 금지).
 */
export const tooltipBubbleSurfaceCss = css`
  justify-content: center;
  align-items: center;
  z-index: ${inlineOverlayZIndex.tooltip};
  width: max-content;
  max-width: 16rem;
  padding: 0.3rem 0.5rem;
  border-radius: ${({ theme }) => theme.shape.radius.tooltip};
  font-size: ${({ theme }) => theme.typography.size.caption};
  white-space: normal;
  word-wrap: break-word;
  background-color: ${({ theme }) => theme.color.bg.control.primaryActive};
  color: ${({ theme }) => theme.color.text.onControl};
`;
